export class Counselling {
  sCounsellingType: number;
  sCounsellingTypeDesc : string;
  sCompleteDate: string;
  sProviderId: string;
  sCounsellingFormatType: number;
  sCounsellingFormatTypeDesc : string;
  sProviderName: string;
  sConfirmationFlag: boolean;
  sProviderType: number;
  sProviderTypeDesc : string;

}
